import { translate } from '@teamleader/i18n';
import React from 'react';

import Banner from '../../../../Components/UI/Banner';

const RefusedBanner: React.FC = () => {
  return <Banner label={translate('refusedQuotation.banner')} variant="error" />;
};

export default RefusedBanner;
